<template>
  <div>
    <live-wait-status-legend />
    <el-table
      :data="routes"
      row-key="route_id"
      header-row-class-name="thead-desing"
      :row-class-name="rowClassName"
      class="table-responsive desing live-wait-table"
    >
      <el-table-column :label="texts.ROUTE" min-width="90px">
        <template v-slot="{ row }"><strong>{{ row.dealer_name }}</strong></template>
      </el-table-column>
      <el-table-column :label="texts.DEALER" min-width="200px">
        <template v-slot="{ row }">{{ row.dealer_person_name || texts.EMPTY_CELL }}</template>
      </el-table-column>
      <el-table-column :label="texts.SCHEDULED_HOUR" min-width="110px">
        <template v-slot="{ row }">{{ scheduledHour(row) }}</template>
      </el-table-column>
      <el-table-column :label="texts.ARRIVED_AT" min-width="90px">
        <template v-slot="{ row }">{{ arrivalHour(row) }}</template>
      </el-table-column>
      <el-table-column :label="texts.DEALER_WAIT" min-width="110px">
        <template v-slot="{ row }">
          <dealer-wait-counter :route="row" :server-now="serverNow" @seconds-change="rememberSeconds" />
        </template>
      </el-table-column>
      <el-table-column :label="texts.WAIT_STATUS" min-width="170px">
        <template v-slot="{ row }">
          <live-wait-status-tag :status="statusOf(row)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui'
import { shortClockTime } from '@/utils/kitchenWaitCounter'
import DealerWaitCounter from './DealerWaitCounter.vue'
import LiveWaitStatusLegend from './LiveWaitStatusLegend.vue'
import LiveWaitStatusTag from './LiveWaitStatusTag.vue'
import { DELIVERY_TEXTS } from '../deliveryConstants'
import { WAIT_STATE } from '../kitchenWaitConstants'
import { describeLiveWaitStatus } from '../liveWaitStatus'

export default {
  name: 'DealerWaitTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DealerWaitCounter,
    LiveWaitStatusLegend,
    LiveWaitStatusTag
  },
  props: {
    routes: {
      type: Array,
      required: true
    },
    serverNow: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      liveSecondsByRouteId: {}
    }
  },
  computed: {
    texts () {
      return DELIVERY_TEXTS
    }
  },
  methods: {
    scheduledHour (route) {
      return shortClockTime(route.scheduled_departure_time) || this.texts.NO_SCHEDULE
    },
    arrivalHour (route) {
      return shortClockTime(route.arrival_time) || this.texts.EMPTY_CELL
    },
    rowClassName ({ row }) {
      return row.state === WAIT_STATE.STARTED ? 'text-muted' : ''
    },
    rememberSeconds (routeId, seconds) {
      this.$set(this.liveSecondsByRouteId, routeId, seconds)
    },
    statusOf (route) {
      const liveSeconds = this.liveSecondsByRouteId[route.route_id]

      return describeLiveWaitStatus(route, liveSeconds === undefined ? route.wait_seconds : liveSeconds)
    }
  }
}
</script>

<style scoped>
.live-wait-table ::v-deep .cell {
  word-break: normal;
}
.live-wait-table ::v-deep th,
.live-wait-table ::v-deep td {
  padding-left: 12px;
  padding-right: 12px;
}
.live-wait-table ::v-deep .el-table__body .cell {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
</style>
